import { call, put, takeLatest } from 'redux-saga/effects';
import { actions as newsActions } from 'store/news/slice';
import { newsService, newsSampleService } from './services';

/**
 * News request/response handler
 */
export function* fetchNewsSaga({
  payload,
}: ReturnType<typeof newsActions.fetchTrigger>) {
  try {
    const { data } = yield call(newsService, payload);

    yield put(newsActions.fetchSuccess(data));
  } catch (err) {
    // @ts-ignore
    yield put(newsActions.fetchFailed(err));
  } finally {
    yield put(newsActions.fetchFulfilled());
  }
}

/**
 * News request/response handler
 */
export function* fetchNewsSampleSaga({
  payload,
}: ReturnType<typeof newsActions.fetchSampleTrigger>) {
  try {
    const { data } = yield call(newsSampleService, payload);

    yield put(newsActions.fetchSampleSuccess(data));
  } catch (err) {
    // @ts-ignore
    yield put(newsActions.fetchSampleFailed(err));
  } finally {
    yield put(newsActions.fetchSampleFulfilled());
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export function* newsSaga() {
  yield takeLatest(newsActions.fetchTrigger.type, fetchNewsSaga);
  yield takeLatest(newsActions.fetchSampleTrigger.type, fetchNewsSampleSaga);
}
